
import uiMixin from '@/mixins/uiMixin';

export default {
  mixins: [uiMixin],
  data() {
    return {
      tiers: [
        {
          id: 'tier7',
          text: 'Tier 7: 0 - 100 referrals | 20% commission',
          style: {
            width: '25%',
            borderBottom: '50px solid rgb(77, 107, 242, 0.3)',
          },
        },
        {
          id: 'tier6',
          text: 'Tier 6: 101 - 500 referrals | 25% commission',
          style: {
            borderBottom: '50px solid rgb(77, 107, 242, 0.4)',
            width: '35%',
          },
        },
        {
          id: 'tier5',
          text: 'Tier 5: 501 - 1000 referrals | 30% commission',
          style: {
            borderBottom: '50px solid rgb(77, 107, 242, 0.5)',
            width: '45%',
          },
        },
        {
          id: 'tier4',
          text: 'Tier 4: 1001 - 5000 referrals | 35% commission',
          style: {
            borderBottom: '50px solid rgb(77, 107, 242, 0.6)',
            width: '55%',
          },
        },
        {
          id: 'tier3',
          text: 'Tier 3: 5001 - 10000 referrals | 40% commission',
          style: {
            borderBottom: '50px solid rgb(77, 107, 242, 0.7)',
            width: '65%',
          },
        },
        {
          id: 'tier2',
          text: 'Tier 2: 10001 - 50000 referrals | 45% commission',
          style: {
            borderBottom: '50px solid rgb(77, 107, 242, 0.8)',
            width: '75%',
          },
        },
        {
          id: 'tier1',
          text: 'Tier 1: 50001+ referrals | 50% commission',
          style: {
            borderBottom: '50px solid rgb(77, 107, 242)',
            width: '85%',
          },
        },
      ],
    };
  },
  mounted() {
    if(this.$posthog.isFeatureEnabled('add-posthog-marketplace')){
        this.$posthog.capture('affiliate_page_viewed');
      }
  },
  methods: {
    toAffiliateSignupPage() {
      if(this.$posthog.isFeatureEnabled('add-posthog-marketplace')){
        this.$posthog.capture('clicked_affiliate_signup');
      }
      this.$router.push('/affiliate/join');
    },
  },
};
